import React, { Component } from 'react';
import { Switch } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { formDataSchema } from '../../../../schema/privilege';
import Inputlayer from '../../../../components/FormComponent/Input';
import { Modal, Button } from 'antd';
import { mapObjIndexed } from 'ramda';
import networkList from '../../../../constants/networkList';
const $ = require('jquery');
const {homepage} = networkList;

class Privilege_Create extends Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            formData: []
        }
    }
    showModal = () => {
        this.setState({
            visible: true
        })
    }
    componentDidMount() {

    }
    handleCancel = e => {
        console.log(e)
        this.setState({ visible: false })
    }
    onChange(checked) {
        console.log(`switch to ${checked}`);
    }
    render() {
        return (
            <div>
                <div className="card m-5 card-table">
                    <div className="p-5">
                        <h1 className="text-heading text-center">Privilege Creation</h1>

                        {formDataSchema.feilds
                            .map((feild, key) => {

                                if (feild.element === 'input1') {
                                    return (
                                        <div className="row pt-4 pl-5 pr-5 justify-content-center">

                                            <div
                                                className={`${feild.className
                                                    ? feild.className
                                                    : 'col'} my-2 ${feild.name}`}
                                                key={key}>
                                                <div className="clearfix">
                                                    <p className="data-label w-100 mb-1">{feild.text}</p>
                                                </div>
                                                <Inputlayer
                                                    {...this.props}
                                                    {...this.state}
                                                    feildData={feild}

                                                />
                                            </div>
                                            <div className="col-2 mt-3 pt-3">
                                                <button className="btn btn-success text-capitalize">create</button>
                                            </div>
                                        </div>
                                    )
                                }
                            })
                        }

                    </div>
                    <div className="financial-table table-responsive">
                        <table className="table table-hover table-bordered mb-0">
                            <thead>
                                <tr>
                                    <td>S.No</td>
                                    <td>Service Name</td>
                                    <td>Created By</td>
                                    <td>Creation Date</td>
                                    <td>Status</td>
                                    <td>Action</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>01</td>
                                    <td>(ER) Admission</td>
                                    <td>Raju Manager 20135</td>
                                    <td>14 Feb 2020</td>
                                    <td><Switch onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" onClick={this.showModal}></img></td>
                                </tr>
                                <tr>
                                    <td>01</td>
                                    <td>(ER) Admission</td>
                                    <td>Raju Manager 20135</td>
                                    <td>14 Feb 2020</td>
                                    <td><Switch onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" onClick={this.showModal}></img></td>
                                </tr>
                                <tr>
                                    <td>02</td>
                                    <td>(ER) Financial Counselling</td>
                                    <td>Raju Manager 20135</td>
                                    <td>14 Feb 2020</td>
                                    <td><Switch onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" onClick={this.showModal}></img></td>
                                </tr>
                                <tr>
                                    <td>03</td>
                                    <td>(ER) Billing Queries</td>
                                    <td>Raju Manager 20135</td>
                                    <td>14 Feb 2020</td>
                                    <td><Switch defaultChecked onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" onClick={this.showModal}></img></td>
                                </tr>
                                <tr>
                                    <td>04</td>
                                    <td>Admission</td>
                                    <td>Raju Manager 20135</td>
                                    <td>14 Feb 2020</td>
                                    <td><Switch defaultChecked onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" onClick={this.showModal}></img></td>
                                </tr>
                                <tr>
                                    <td>05</td>
                                    <td>Financial Counselling</td>
                                    <td>Raju Manager 20135</td>
                                    <td>14 Feb 2020</td>
                                    <td><Switch onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" onClick={this.showModal}></img></td>
                                </tr>
                                <tr>
                                    <td>06</td>
                                    <td>Re-Counseling</td>
                                    <td>Raju Manager 20135</td>
                                    <td>14 Feb 2020</td>
                                    <td><Switch defaultChecked onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" onClick={this.showModal}></img></td>
                                </tr>
                                <tr>
                                    <td>07</td>
                                    <td>Discharge & Checkout</td>
                                    <td>Raju Manager 20135</td>
                                    <td>14 Feb 2020</td>
                                    <td><Switch defaultChecked onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" onClick={this.showModal}></img></td>
                                </tr>
                                <tr>
                                    <td>08</td>
                                    <td>Billing Queries</td>
                                    <td>Raju Manager 20135</td>
                                    <td>14 Feb 2020</td>
                                    <td><Switch defaultChecked onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" onClick={this.showModal}></img></td>
                                </tr>
                                <tr>
                                    <td>09</td>
                                    <td>Payment</td>
                                    <td>Raju Manager 20135</td>
                                    <td>14 Feb 2020</td>
                                    <td><Switch onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" onClick={this.showModal}></img></td>
                                </tr>
                                <tr>
                                    <td>20</td>
                                    <td>Reimbursement</td>
                                    <td>Raju Manager 20135</td>
                                    <td>14 Feb 2020</td>
                                    <td><Switch defaultChecked onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" onClick={this.showModal}></img></td>
                                </tr>
                            </tbody>
                        </table>
                        <Modal visible={this.state.visible} onCancel={this.handleCancel} footer={null} >                     
                        <div className="p-5">
                            <h3 className="text-center" style={{'fontfamily':'normal'}}>Edit Privilege</h3>
                            
                        {formDataSchema.feilds
                            .map((feild, key) => {

                                if (feild.element === 'edit') {
                                    return (
                                        <div className="row pt-4 pl-5 pr-5 pb-5">

                                            <div
                                                className={`${feild.className
                                                    ? feild.className
                                                    : 'col'} my-2 ${feild.name}`}
                                                key={key}>                                              
                                                    <p className="data-label w-100 mb-1">{feild.text}</p>                                            
                                                <Inputlayer
                                                    {...this.props}
                                                    {...this.state}
                                                    feildData={feild}

                                                />
                                            </div>                                          
                                        </div>
                                    )
                                }
                            })
                        }
                            <div className="row justify-content-center">
                        <button className="btn btn-success text-capitalize mr-3" onClick={this.handleCancel}>Submit</button>
                        <button className="btn btn-success btn-next text-capitalize" onClick={this.handleCancel}>cancel</button>
                    </div>
                        </div>
                    </Modal>
                    </div>
                </div>
            </div>
        )
    }
}

export default Privilege_Create;